import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card, Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import SelecionarCategoriaFinancas from '../components/Utils/SelecionarCategoriaFinancas';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import AOS from "aos";
import 'aos/dist/aos.css';
import { useProvider, Toast } from '../context/MenuProvider';


import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const FluxoDeCaixa = () => {
    const [query, setQuery] = useState('');
    const [pagamentos, setPagamentos] = useState([]);
    const [extra, setExtra] = useState(null);
    const [status, setStatus] = useState("");
    const [filtroPagamento, setFiltroPagamento] = useState('todos');
    const [avancada, setAvancada] = useState(false);
    const [mesMenu, setMesMenu] = useState({});
    const [nextUrl, setNextUrl] = useState(null);
    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');
    const { 
      setLinks, 
      setBtns,
      crudAdmin,
      salvarDados,
      buscarDados,
      buscarDadosPorId,
    } = useProvider();
    const [categoriaId, setCategoriaId] = useState(null);
    const [paginaDB, setPaginaDB] = useState(1);
    
    
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const receita = queryParams.get('receita')?.toLowerCase() || null;
    
    useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
    }, []);


    const carregarMesMenu = (deslocamento = 0) => {
      const [ ano, mes, dia ] = dataInicio.split('-')
      const data = dataInicio ? new Date(ano, parseInt(mes)-1) : new Date();
 
      data.setMonth(data.getMonth() + deslocamento);
      
      // Obtém o nome do mês atual
      const mesAtual = data.toLocaleString('default', { month: 'long' });
    
      // Configura os valores do menu
      setMesMenu({
        anterior: new Date(data.getFullYear(), data.getMonth() - 1).toLocaleString('default', { month: 'long' }),
        atual: `${mesAtual}/${data.getFullYear()}`,
        proximo: new Date(data.getFullYear(), data.getMonth() + 1).toLocaleString('default', { month: 'long' }),
      });
    
      // Define a data inicial e final do mês atual
      setDataInicio(new Date(data.getFullYear(), data.getMonth(), 1).toISOString().split('T')[0]);
      setDataFim(new Date(data.getFullYear(), data.getMonth() + 1, 0).toISOString().split('T')[0]); // Último dia do mês
    };
    

    useEffect(()=>{
      if(!avancada) carregarMesMenu();
    }, [avancada, setDataInicio, setDataFim]);
    
    const { get, loading } = crudAdmin || {};
    
    
    const isConsultaCarregada = useRef(false);
    const buscarPagamentosLocal = async (novaBusca = false) =>{
      try{
        //alert(`Inicio: ${dataInicio}\nFim: ${dataFim}\nPagina: ${paginaDB}`);
        if(novaBusca){
          setPagamentos([]);
        } else if(paginaDB === 0) return;
        
        
        const response = await buscarDados(
          "db_pagamentos",
          (item) =>{
            const dataItem = new Date(item.data_do_pagamento).getTime();
            const dataIn = new Date(dataInicio).getTime();
            const hoje = new Date(new Date().toLocaleDateString('sv-SE')).getTime();
            const dataOut = new Date(dataFim).getTime();
            const periodos = (dataInicio && dataFim)
                ? dataItem >= dataIn && dataItem <= dataOut
                : (dataInicio) ? dataItem >= dataIn : (dataFim) ? dataItem <= dataOut : true;
                
            let filtrosAvancados = true;    
            
            switch(receita){
              case `true`:
                if (filtroPagamento === 'pago') filtrosAvancados = item.pago;
                else if (filtroPagamento === 'atrasado') filtrosAvancados = !item.pago && dataItem < hoje;
                //else if (filtroPagamento === 'calotes') url += `&atrasado=true&status_ativo=false`;
                else if (filtroPagamento === 'vencer') filtrosAvancados = !item.pago && dataItem >= hoje;
                else if (filtroPagamento === 'aberto') filtrosAvancados = !item.pago;
                break;
              case `false`:
                // if (categoriaId){
                //   switch(categoriaId){
                //     case "pessoais":
                //       filtrosAvancados = item.tipo === categoriaId;
                //       break;
                //     case "negocio":
                //       url += `&tipo=${categoriaId}`;
                //       break;
                //     default:
                //       url += `&categoria_ids=${categoriaId}`;
                //       break;
                //   }
                // }
                // if (status){
                //   switch(status){
                //     case "pago":
                //       url += `&pago=true`;
                //       break;
                //     case "atrasado":
                //       url += `&atrasado=true&status_ativo=true`;
                //       break;
                //     case "proximos":
                //       url += `&pago=false&atrasado=false`;
                //       break;
                //     case "aberto":
                //       url += `&pago=false`;
                //       break;
                //   }
                // }
                break;
            }
            
            
            return item.pago && periodos && filtrosAvancados;
          },
          15,
          "data_do_pagamento",
          "desc",
          paginaDB,
        );
        if (isConsultaCarregada.current) return;
        if (response && response.length){
          for (let item of response){
            if(item.venda){
              item.venda = await buscarDadosPorId("db_vendas", parseInt(item?.venda?.id || item?.venda || 0));
              item.venda.cliente = await buscarDadosPorId("db_clientes", parseInt(item?.venda?.cliente?.id || item?.venda?.cliente || 0));
            } else if(item.financeiro){
              item.financeiro = await buscarDadosPorId("db_financas", parseInt(item?.financeiro?.id || item?.financeiro || 0));
              if(item.financeiro){
                item.financeiro.categoria = await buscarDadosPorId("db_categorias", parseInt(item?.financeiro?.categoria?.id || item?.financeiro?.categoria || 0));
              }
            }
          }
          if(novaBusca){
            setPagamentos(response);
            setPaginaDB(1);
          }else{
            setPagamentos((prev) => [
              ...prev,
              ...(Array.isArray(response) ? response : [response]),
            ]);
            setPaginaDB(paginaDB+1);
          }
        }else{
          setPaginaDB(0);
        }
      }catch(err){
        
      }finally{
        
      }
    }
    

    // Função para buscar pagamentos na API
    const buscarPagamentos = async (novaBusca = false) => {
        let url = `/gvendas/pagamentos/?ordering=-data_do_pagamento&pago=true`;
        if (query) url += `&search=${query}`;
        
        if (dataInicio) url += `&data_do_pagamento__gte=${dataInicio}`;
        if (dataFim) url += `&data_do_pagamento__lte=${dataFim}`;
        let expand = ``;
        let filter = ``;
        
        expand =`venda,cliente,financeiro,categoria`;
        filter =`${expand},nome,ativo,nome_da_categoria,observacoes`;
        
        url += `&expand=${expand},extra`
        url += `&filtros=forma_de_pagamento,data_do_pagamento,valor_total,pago,vence_hoje,is_atrasado,id,${filter}`

        if (novaBusca) {
            setNextUrl(null);
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (!url) return;
        //alert(url)
        try{
          const response = await get(url, 'pagina');
          if (response && response.length){
            isConsultaCarregada.current = true;
            const novosItens = response[0].results;
            //alert(JSON.stringify(novosItens))
            setPagamentos((itensAnteriores) => novaBusca ? novosItens : [...itensAnteriores, ...novosItens]);
            setExtra(response[0]?.extra?.saldo);
            setNextUrl(response[0].next);
            await salvarDados("db_pagamentos", novosItens);
          }else{
            setPagamentos([]);
            setExtra(null);
          }
        }catch(err){
            setExtra(null);
          ///
          // Toast.fire({
          //   icon: "error",
          //   title: "Falha ao buscar pagamentos"
          // });
        }finally{
          
        }
    };
    
    useEffect(() => {
      setLinks([
        { name: 'Nova Receita', to: '/checkout/selecionar-cliente' },
        { name: 'Nova Despesa', to: '/nova-despesa' },
      ]);
      
      setBtns([
        {icon:'bi-funnel'+(avancada?'-fill':''), onClick:() => {setAvancada(!avancada);}},
      ]);
      return () => {setLinks([]); setBtns([]);}
    }, [setLinks, setBtns, avancada, setAvancada]);
    
    

    // Carrega todos os pagamentos ao montar o componente ou ao aplicar um novo filtro
    useEffect(() => {
      buscarPagamentosLocal(true);
      buscarPagamentos(true);
    }, [query, filtroPagamento, setDataInicio, dataInicio, dataFim, mesMenu, categoriaId, status]);

    // Detecta o fim da página para carregar mais pagamentos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarPagamentosLocal();
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [nextUrl, loading, paginaDB, dataInicio, dataFim, filtroPagamento]);
    
    

    const realizarNovaBusca = () => {
        buscarPagamentosLocal(true);
    };
    
    const realizarNovoCarregamento = () => {
        buscarPagamentosLocal(false);
    };
    
    const pagamentosAgrupadas = pagamentos.reduce((acc, venda) => {
      const data = dayjs(venda.data_do_pagamento).format("DD/MM/YYYY dddd"); // Assumindo que data_da_venda está no formato desejado
      if (!acc[data]) {
        acc[data] = [];
      }
      acc[data].push(venda);
      return acc;
    }, {});

    return (
      <>
        <MenuRodape total={extra}/>
        <div className="">
            <Form>
                {avancada && (
                  <Form.Group controlId="formBasicSearch">
                        <Form.Control 
                          type="text" 
                          placeholder="Digite a pesquisa" 
                          value={query} 
                          onChange={(e) => setQuery(e.target.value)} 
                        />
                  </Form.Group>
                )}
                {!avancada && (
                  <>
                    <Row className="align-items-center">
                      <Col onClick={()=>carregarMesMenu(-1)}>{mesMenu.anterior}</Col>
                      <Col className="text-center fs-4">{mesMenu.atual}</Col>
                      <Col className="text-end" onClick={()=>carregarMesMenu(1)}>{mesMenu.proximo}</Col>
                    </Row>
                  </>
                )}
                {avancada && (
                  <>
                    <Form.Group controlId="formDateRange" className="mt-3">
                        <Form.Label>Período</Form.Label>
                         <div className="input-group">
                          <span className="input-group-text">De</span>
                          <Form.Control
                            type="date"
                            value={dataInicio}
                            onChange={(e) => setDataInicio(e.target.value)}
                          />
                          <span className="input-group-text">até</span>
                          <Form.Control
                            type="date"
                            value={dataFim}
                            onChange={(e) => setDataFim(e.target.value)}
                          />
                        </div>
                    </Form.Group>
                    
                    <Button variant="secondary" onClick={realizarNovaBusca} className="mt-2 w-100">
                        Buscar
                    </Button>
                  </>
                )}
                
            </Form>
            

          <div className="list-group mt-3">
            {Object.entries(pagamentosAgrupadas).length>0?(
              Object.entries(pagamentosAgrupadas).map(([data, pagamentosDoDia], index) => (
                <div key={data}>
                  <div className="text-muted mt-2" data-aos="fade-up" data-aos-delay={parseInt(`${index}00`)}>{data}</div>
                    {pagamentosDoDia.map((x, index_f) => (
                      <div data-aos="fade-up" data-aos-delay={parseInt(`${index+index_f}00`)}>
                        <RenderizarProduto
                          key={x.id}
                          to={x.venda?`/vendas/${x.venda?.id || x.venda}/${x.id}`:`/despesas/editar/${x.financeiro?.id || x.financeiro}`}
                          lm="mb-1"
                          col="d-none"
                          col2="col-auto text-end"
                          text1={x.venda?.cliente?.nome??x.financeiro?.categoria?.nome_da_categoria}
                          titulo3={parseFloat(parseFloat(x.valor_total)*(x.venda?1:-1)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                          text2={x.venda?`Recebido em ${x.forma_de_pagamento}`:x.financeiro?.observacoes||``}
                          bcolor={x.venda ? '#90ee90' : '#f08080'}
                          text3={x.venda?'entrada':'saída'}
                        />
                      </div >
                    ))}
                  </div>
              ))
            ):(
              !loading && <p data-aos="fade-up" className="text-center text-muted">Nenhum pagamento encontrado.</p>
            )}
            {loading && <p data-aos="fade-up" className="text-center"><Spinner animation="border" /></p>}
            {(!loading && nextUrl) && (
              <Button variant="secondary" data-aos="fade-up" onClick={() => buscarPagamentosLocal(false)} className="mt-2">
                  Buscar mais...
              </Button>
            )}
          </div>
        </div>
      </>
    );
};

const MenuRodape = ({ total }) => {
  if (total === null) return;
  return (
    <div className="bs-floating shadow navbar-light">
      <div className="container py-1">
        <div className="row align-items-center">
          <div className="text-end">
            Saldo {' '} 
            <span
              className="fs-4"
              style={{ color: parseFloat(total || 0) < 0 ? 'red' : 'inherit' }}
            >
              {parseFloat(total || 0).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FluxoDeCaixa;